"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const getIntegerFromUnknown_1 = __importDefault(require("../../shared/getIntegerFromUnknown"));
const setTimeOutBuilder = ({ entryVars: { delay: entryDelay, }, callbacks, executeProcesses, processor, functionId, }) => {
    try {
        const delay = (0, getIntegerFromUnknown_1.default)(entryDelay);
        const delayMs = delay * 1000;
        if (delayMs > 20000) {
            processor.root.alert('Invalid delay', `Your delay ${delay} must be less than or equal to 20 seconds`);
            return;
        }
        processor.root.registerTimeout(() => {
            executeProcesses(functionId, callbacks.onDone);
        }, delayMs);
    }
    catch (error) {
        processor.root.alert('Invalid number', `${error}`);
    }
};
exports.default = setTimeOutBuilder;
